import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getCustomSurveyTemplateById,
  CustomSurveyTemplate,
} from '../../api/customSurveyTemplates';
import { customSurveyTemplateKeys } from './queryKeys';

export const useGetCustomSurveyTemplateByIdQuery = (
  templateId: number | null,
  options?: Omit<
    UseQueryOptions<CustomSurveyTemplate, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<CustomSurveyTemplate, Error>({
    queryKey: customSurveyTemplateKeys.detail(templateId ?? 0),
    queryFn: () => getCustomSurveyTemplateById(templateId!),
    enabled: templateId !== null && !isNaN(templateId),
    ...options,
  });
};
